import { FadeUp } from "../components/Animations";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const ABOUT_IMG = "https://customer-assets.emergentagent.com/job_elevated-spaces-1/artifacts/k27o4ldi_IMG_0966.JPG";
const DETAIL_IMG = "https://customer-assets.emergentagent.com/job_elevated-spaces-1/artifacts/aiz9xm1u_IMG_0949.JPG";

export default function AboutPage() {
  return (
    <div data-testid="about-page" className="pt-20">
      {/* ── Hero ── */}
      <section className="py-20 md:py-28 px-6 md:px-16 max-w-[1400px] mx-auto">
        <FadeUp>
          <p className="text-xs tracking-[0.3em] uppercase text-taupe mb-8">
            About
          </p>
        </FadeUp>
        <FadeUp delay={0.1}>
          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-light text-onyx leading-[1.05] max-w-3xl">
            Design with conviction. Build with care.
          </h1>
        </FadeUp>
      </section>

      {/* ── Founder ── */}
      <section className="px-6 md:px-16 max-w-[1400px] mx-auto pb-24 md:pb-32">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-start">
          <FadeUp>
            <div className="img-scale aspect-[3/4] w-full">
              <img
                src={ABOUT_IMG}
                alt="Jamie Weaver, Founder"
                className="w-full h-full object-cover"
              />
            </div>
          </FadeUp>

          <div className="md:pt-12">
            <FadeUp delay={0.15}>
              <p className="text-xs tracking-[0.3em] uppercase text-taupe mb-6">
                Founder & Lead Designer
              </p>
              <h2 className="font-serif text-3xl md:text-4xl font-light text-onyx mb-2">
                Jamie Weaver
              </h2>
              <p className="text-sm tracking-[0.15em] uppercase text-taupe mb-8 font-light">
                Founder &amp; Principal, Design + Build
              </p>
            </FadeUp>

            <FadeUp delay={0.25}>
              <p className="text-base font-light text-onyx/80 leading-[1.85] mb-6">
                At J Design Haus, every project starts with one guiding
                belief — your space should be as unique as you are. No
                cookie-cutter packages. Every design plan is fully customized to
                your vision, lifestyle, and goals.
              </p>
            </FadeUp>

            <FadeUp delay={0.35}>
              <p className="text-base font-light text-onyx/80 leading-[1.85] mb-6">
                From the construction side of design to the fine details of
                space planning, furniture selection, and decor styling — a
                background in project management allows oversight of every
                phase, ensuring the build, layout, and design come together
                seamlessly.
              </p>
            </FadeUp>

            <FadeUp delay={0.45}>
              <p className="text-base font-light text-onyx/80 leading-[1.85] mb-8">
                Whether reimagining a floor plan, sourcing custom furniture,
                curating one-of-a-kind decor, or managing the construction
                timeline — the process is hands-on, coordinating with
                contractors, managing budgets, sourcing materials, and making it
                smooth and stress-free.
              </p>
            </FadeUp>

            <FadeUp delay={0.55}>
              <Link
                to="/contact"
                data-testid="about-contact-cta"
                className="inline-flex items-center gap-3 text-sm tracking-[0.15em] uppercase font-light text-onyx hover:text-taupe transition-colors"
              >
                Start a Conversation <ArrowRight size={16} />
              </Link>
            </FadeUp>
          </div>
        </div>
      </section>

      {/* ── Philosophy ── */}
      <section className="bg-onyx py-24 md:py-32 px-6 md:px-16">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center">
          <FadeUp>
            <div>
              <p className="text-xs tracking-[0.3em] uppercase text-taupe mb-8">
                Philosophy
              </p>
              <h2 className="font-serif text-3xl md:text-5xl font-light text-bone leading-snug mb-8">
                Distinctive, seamless, and completely you.
              </h2>
              <p className="text-sm font-light text-concrete leading-[1.85] max-w-lg">
                Spaces that are functional, beautiful, and deeply personal.
                From start to finish — bringing your vision to life in a way
                that reflects who you are.
              </p>
            </div>
          </FadeUp>
          <FadeUp delay={0.2}>
            <div className="img-scale aspect-square w-full">
              <img
                src={DETAIL_IMG}
                alt="Interior detail"
                className="w-full h-full object-cover"
              />
            </div>
          </FadeUp>
        </div>
      </section>

      {/* ── Location ── */}
      <section className="py-24 md:py-32 px-6 md:px-16 max-w-[1400px] mx-auto text-center">
        <FadeUp>
          <p className="text-xs tracking-[0.3em] uppercase text-taupe mb-6">
            Based In
          </p>
        </FadeUp>
        <FadeUp delay={0.1}>
          <h2 className="font-serif text-4xl md:text-6xl font-light text-onyx">
            Scottsdale, Arizona
          </h2>
        </FadeUp>
        <FadeUp delay={0.2}>
          <p className="text-sm font-light text-onyx/60 mt-4">
            Serving Phoenix, Paradise Valley, Scottsdale, and surrounding areas
          </p>
        </FadeUp>
      </section>
    </div>
  );
}
